<script>
import api from "@services/api";
export default {
  props: {
    closeModalChamado: {
      type: Function
    },
    chamadoId: null,
    comentarioObrigatorio: {
      type: Boolean
    },
    etapaFluxoId: null,
    changeFluxo: {
      type: Boolean
    }
  },
  created() {
    this.$store.dispatch("alert/clear");
  },
  data() {
    return {
      comentario: null
    };
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    }
  },
  methods: {
    closeAlert() {
      this.$store.dispatch("alert/clear");
    },
    save() {
      if (!this.comentario || this.comentario == "") {
        this.$store.dispatch(
          "alert/error",
          "O campo de comentário não pode ser vazio.",
          { root: true }
        );
      } else {
        let formData = new FormData();
        formData.append("ChamadoId", this.chamadoId);
        formData.append("Comentario", this.comentario);
        api.post(`api/Chamado/insertComentario`, formData).then(response => {
          if (response.data["status"].toLowerCase() == "success") {
            this.hasSuccess = true;
            this.closeModalChamado(
              true,
              this.comentarioObrigatorio,
              this.etapaFluxoId,
              this.changeFluxo
            );
          } else {
            this.closeModalChamado(
              false,
              this.comentarioObrigatorio,
              this.etapaFluxoId,
              this.changeFluxo
            );
            throw response;
          }
        });
        this.comentario = null;
      }
    },
    cancel() {
      this.closeModalChamado(
        false,
        this.comentarioObrigatorio,
        this.etapaFluxoId,
        this.changeFluxo
      );
    }
  }
};
</script>

<template>
  <div>
    <b-alert
      variant="danger"
      dismissible
      :show="alert.show"
      @dismissed="closeAlert"
    >
      {{ alert.message }}
    </b-alert>
    <b-form class="p-2" ref="form">
      <b-form-group
        id="input-group-5"
        label="Comentário"
        label-for="Comentário"
      >
        <b-form-textarea
          id="textarea-large"
          rows="3"
          max-rows="5"
          no-resize
          required
          v-model="comentario"
          autofocus
        ></b-form-textarea>
      </b-form-group>
      <b-button variant="light" @click="cancel">Cancelar</b-button>
      <b-button variant="primary" class="ml-2" @click="save">Salvar</b-button>
    </b-form>
  </div>
</template>
